import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import RenderField from './RenderField';
import CustomAlert from '../components/CustomAlert.js';
import Whatsapp from './WhatsappButton.js';

class EmailForm extends Component {

    constructor(props) {
        super(props);
        this.state = { cities: null };
    }

    render() {

        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_email" description="Email Form"/>
                        <Whatsapp phone={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                  text={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                  value={this.context.intl.formatMessage({
                                      id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                  gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                        <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveEmail)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="email" autoComplete="off" component={RenderField} type="email" label="Email" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Section>
        );
    }
}

EmailForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'email', required: true}]);

EmailForm = TopScrolleable(EmailForm);

EmailForm = reduxForm({
    form: 'EmailForm', // a unique name for this form
    validate
})(EmailForm);

//EmailForm = withAuthControl(EmailForm);

export default EmailForm;


/** WEBPACK FOOTER **
 ** ./src/components/EmailForm.js
 **/